import { Button, Typography } from "antd";
import { NODE_GROUPS, ICONS } from "./nodeTypes";
import { PlusOutlined } from "@ant-design/icons";
import AddEditQuestionModal from "./AddEditQuestionModal";
import { useCallback, useMemo, useState } from "react";
const { Text } = Typography;

const Sidebar = () => {
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questions, setQuestions] = useState({});

  const onDragStart = useCallback((event, item) => {
    const payload = JSON.stringify(item);
    event.dataTransfer.setData("application/reactflow", payload);
    event.dataTransfer.effectAllowed = "move";
  }, []);

  const questionGroup = useMemo(() => {
    return {
      label: "Questions",
      items: Object.entries(questions).map(([key, { type, question, id }]) => ({
        type: "question",
        label: question,
        icon: "QuestionOutlined",
        subLabel: type,
        id,
      })),
    };
  }, [questions]);

  return (
    <aside className="workflow-sidebar">
      <div className="flex justify-space-between align-center">
        <div className="h-100">
          <Text className="workflow-title">Blocks</Text>
        </div>
        <Button
          icon={<PlusOutlined />}
          type="text"
          onClick={() => setSelectedQuestionId({})}
        />
      </div>
      {[questionGroup, ...NODE_GROUPS].map((group) => (
        <div key={group.label} className="workflow-group">
          <Text className="workflow-group-title">{group.label}</Text>

          {group.items.map((item, i) => {
            const Icon = ICONS[item?.icon];

            return (
              <div
                key={i}
                draggable
                onDragStart={(e) => onDragStart(e, item)}
                className="workflow-item"
                onClick={() => {
                  if (group.label === "Questions") {
                    setSelectedQuestionId(item?.id);
                  }
                }}
              >
                {Icon && <Icon className="workflow-item-icon" />}

                <Text className="workflow-item-label">{item.label}</Text>
              </div>
            );
          })}
        </div>
      ))}
      {selectedQuestionId && (
        <AddEditQuestionModal
          onCancel={() => setSelectedQuestionId(false)}
          onSave={(values) => {
            const question = values.questions[0];
            setQuestions((prev) => ({
              ...prev,
              [question.id]: question,
            }));

            setSelectedQuestionId(null);
          }}
          selectedQuestion={questions[selectedQuestionId] || {}}
        />
      )}
    </aside>
  );
};

export default Sidebar;
